/***
 * 创建人：李珊
 * 时间：2020-12-01
 * 描述: 查看素材详情-历史记录模块：查看已添加的实体和关系列表
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
declare var $;
@Component({
  selector: 'app-history-records',
  templateUrl: './history-records.component.html',
  styleUrls: ['./history-records.component.css']
})
export class HistoryRecordsComponent implements OnInit {
  // 输入参数
  @Input() materialId: string;
  @Input() operateState:number;
  // 点击编辑或新增操作时触发
  @Output() addOrUpdate = new EventEmitter();
  //实体表格组件
  @ViewChild("swtable") swtable: SwGridTableComponent;
  //关系表格组件
  @ViewChild("swtable1") swtable1: SwGridTableComponent;
  //输入参数
  @Input() param: any;
  // 是否显示正在加载
  isLoading = false;
  // 实体查询关键字
  instanceName: string = '';
  // 实体数据
  datas: any = [];
  //  表格选中行数据
  selectData: any = [];
  // 按钮数组
  toolbar = [
    { status: true, functionCode: 'add', functionName: '新增', icon: 'glyphicon glyphicon-plus', children: [] },
    // { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-trash', children: [] }
  ];
  // 实体数据分页参数
  pageBase:any = {
    current: 1,
    size: 8
  };
  // 关系查询关键字
  leftName: string = '';
  // 关系数据
  datas1: any = [];
  // 关系数据分页参数
  pageBase1:any = {
    current: 1,
    size: 8
  };
  // 关系表格选中行数据
  selectData1: any = [];
  // 选中的tabId
  selectTabId = 1;
  // 是否展示删除确认弹出框
  showModal = false;
  // 是否为批量删除
  isMultiDelete = true;
  // 单条删除时选中的数据
  selectSimpleData:any;
  constructor(
    private kmsService: KmsService,
    private box: SwMassageBoxService) {
  }

  ngOnInit() {
    
  }

  ngOnChanges(){
    if(this.operateState == 5 && this.materialId){
      this.clickSelect();
    }
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.clickSelect();
    }
  }

  // 查询方法
  clickSelect() {
    if(this.selectTabId == 1){
      this.pageBase = {
        current: 1,
        size: 10
      };
      this.getData();
    }else{
      this.pageBase1 = {
        current: 1,
        size: 10
      };
      this.getData();
    }
  }

  //获取数据列表
  getData() {
    this.isLoading = true;
    if(this.selectTabId == 1){
      const params = {
        'instanceName': $.trim(this.instanceName),
        'materialId': this.materialId,
        'current': this.pageBase.current,
        'size': this.pageBase.size
      }
      this.kmsService.queryMaterialRecordList(params).subscribe(
        data => {
          this.isLoading = false;
          if (data.code == '200') {
            if(data.data){
              this.pageBase = data.data;
              this.datas = data.data.records;
            }else{
              this.datas = [];
              this.pageBase = {
                current: 1,
                size: 8,
                pages: 0,
                total: 0
              }
            }
          } else {
            this.box.waring(data.msg);
          }
        }
      );
    }else{
      const params = {
        'startNode': {
          nodeName: $.trim(this.leftName)
        },
        'dataSourceId': this.materialId,
        'current': this.pageBase1.current,
        'size': this.pageBase1.size
      }
      this.kmsService.getRelationshipList(params).subscribe(
        data => {
          this.isLoading = false;
          if (data.code == '200') {
            if(data.data){
              this.pageBase1 = data.data;
              this.datas1 = data.data.records;
            }
          } else {
            this.box.waring(data.msg);
          }
        }
      );
    }
  }

  // 重置方法
  clickReload() {
    if(this.selectTabId == 1){
      this.instanceName = '';
      this.pageBase = {
        current: 1,
        size: 10
      };
      this.getData();
    }else{
      this.leftName = '';
      this.pageBase1 = {
        current: 1,
        size: 10
      };
      this.getData();
    }
  }

  //  表格选择数据
  outSelectData(event) {
    if(this.selectTabId == 1){
      //获取当前选中的所有数据
      this.selectData = event;
      //设置表格按钮组状态
      this.swtable.toolbarAllEnable();
      if (this.selectData.length != 1) {
        this.swtable.toolbarDisable("edit");
      };
      if (this.selectData.length == 0) {
        this.swtable.toolbarDisable("delete");
      };
    }else{
      //获取当前选中的所有数据
      this.selectData1 = event;
      //设置表格按钮组状态
      this.swtable1.toolbarAllEnable();
      if (this.selectData1.length != 1) {
        this.swtable1.toolbarDisable("edit");
      };
      if (this.selectData1.length == 0) {
        this.swtable1.toolbarDisable("delete");
      };
    }
  }

  // 按钮点击事件
  onOperation(event) {
    switch (event) {
      // 新增
      case 'add':
        this.clickAdd();
        break;
      // 删除
      case 'delete':
        this.clickDelete();
        break;
    }
  }

  //新增
  clickAdd() {
    if(this.selectTabId == 1){
      this.addOrUpdate.emit({'type':'instance','data':{}});
    }else{
      this.addOrUpdate.emit({'type':'relation','data':{}});
    }
  }

  //删除
  clickDelete() {
    if(this.selectTabId == 1){
      if (this.selectData.length == 0) {
        this.box.danger('请至少选择一条数据！');
        return;
      };
      this.showModal = true;
    }else{
      if (this.selectData1.length == 0) {
        this.box.danger('请至少选择一条数据！');
        return;
      };
      this.showModal = true;
      this.isMultiDelete = true;
    }
  }

  // 删除数据
  delete(){
    this.showModal = false;
    if(this.selectTabId == 1){
      let selectDatas = this.isMultiDelete ? this.selectData : [this.selectSimpleData];
      let ids = [];
      selectDatas.forEach(item => {
        ids.push(item.instanceId);
      });
      this.kmsService.deleteInstanceById(ids).subscribe(
        data => {
            if (data.code == 200) {
              this.box.success('删除成功！');
              this.clickReload();
              this.selectData = [];
              this.selectSimpleData = null;
            } else {
              this.box.waring(data.msg);
            }
        },
        error => {
          this.box.waring('服务器异常，请稍后再试！');
        }
      )
    }else{
      let selectDatas = this.isMultiDelete ? this.selectData : [this.selectSimpleData];
      let params = [];
      selectDatas.forEach(item => {
        params.push({
          startNodeId: item.sourceUUID,
          uuid: item.properties.uuid
        })
      });
      this.kmsService.deleteRelationshipById(params).subscribe(
        data => {
          if (data.code == '200') {
            this.box.success('删除成功！');
            this.clickReload();
            this.selectData1 = [];
            this.selectSimpleData = null;
          } else {
            this.box.waring(data.msg);
          }
        },
        error => {
          this.box.waring('服务器异常，请稍后再试！');
        }
      );
    }
  }

  // 分页点击方法
  clickPageQuery(event) {
    if(this.selectTabId == 1){
      this.pageBase['pageNum'] = event.current;
      this.pageBase['pageSize'] = event.size;
    }else{
      this.pageBase1['pageNum'] = event.current;
      this.pageBase1['pageSize'] = event.size;
    }
    this.getData();
  }

  // 切换tab
  tabChange(index){
    this.selectTabId = index;
    this.getData();
  }

  /**
  * 点击td中的按钮
  * @ignore
  */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 编辑实体
    if (type == 'editInstance') {
      this.addOrUpdate.emit({'type':'instance','data':data});
    }
    // 删除实体
    else if (type == 'deleteInstance') {
      this.showModal = true;
      this.selectSimpleData = data;
      this.isMultiDelete = false;
    }
    // 编辑关系
    else if (type == 'editRelation') {
      this.addOrUpdate.emit({'type':'relation','data':data});
    }
    // 删除关系
    else if (type == 'deleteRelation') {
      this.showModal = true;
      this.selectSimpleData = data;
      this.isMultiDelete = false;
    }
  }
}


